import { onLevelOneClick } from './on_level_one_click';

export const initialize = ($nav, setCurrentNavLabel) =>
    $nav.on(
        'click',
        '.navigation-level-1__link:not([href])',
        onLevelOneClick($nav, setCurrentNavLabel)
    );
